import { jsx } from 'react/jsx-runtime';
import { useTheme } from 'react-jss';
import { safeRest } from '@wds/utils';
import { createMemoStyles } from '@wds/styles';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var useStyles = createMemoStyles(function (theme) {
  var palette = theme.palette,
    radius = theme.radius,
    shadow = theme.shadow;
  var button = {
    borderRadius: radius.small,
    boxShadow: shadow.none
  };
  return {
    wrenchButtonGroup: {
      boxSizing: 'border-box',
      display: 'inline-flex',
      boxShadow: button.boxShadow,
      borderRadius: button.borderRadius,
      // supports Buttons as well as Buttons that are nested in a Menu
      '& > button, & > a, & > span > button, & > span > a': {
        borderRadius: 0,
        boxShadow: 'none',
        marginLeft: 0,
        marginRight: 0
      },
      '& > button.wrenchButton--alt:hover, & > button.wrenchButton--alt:focus': {
        zIndex: theme.elevation.space
      },
      '& > button:first-child, & > a:first-child, & > span:first-child > button, & > span:first-child > a': {
        borderTopLeftRadius: button.borderRadius,
        borderBottomLeftRadius: button.borderRadius
      },
      '& > button:last-child, & > a:last-child, & > span:last-child > button, & > span:last-child > a': {
        borderTopRightRadius: button.borderRadius,
        borderBottomRightRadius: button.borderRadius
      },
      '& > button:not(.wrenchButton--ghost):not(:first-child), & > a:not(.wrenchButton--ghost):not(:first-child), & > span:not(:first-child) > button:not(.wrenchButton--ghost), & > span:not(:first-child) > a:not(.wrenchButton--ghost)': {
        borderLeft: [1, 'solid', palette.background.light],
        borderLeftWidth: function (_a) {
          var radio = _a.radio;
          return radio && '0';
        }
      },
      '& > button.wrenchButton--ghost:not(:first-child), & > a.wrenchButton--ghost:not(:first-child), & > span:not(:first-child) > button.wrenchButton--ghost, & > span:not(:first-child) > a.wrenchButton--ghost': {
        borderLeft: 'none'
      },
      '& > button.wrenchButton--alt:not(:first-child), & > a.wrenchButton--alt:not(:first-child), & > span:not(:first-child) > button.wrenchButton--alt, & > span:not(:first-child) > a.wrenchButton--alt': {
        borderLeft: 'none'
      }
    }
  };
});

var ButtonGroup = function ButtonGroup(_a) {
  var _b = _a.radio,
    radio = _b === void 0 ? false : _b,
    children = _a.children,
    props = __rest(_a, ["radio", "children"]);
  var theme = useTheme();
  var wrenchButtonGroup = useStyles({
    radio: radio,
    theme: theme
  }).wrenchButtonGroup;
  return jsx("div", __assign({
    role: "group",
    className: wrenchButtonGroup
  }, safeRest(props), {
    children: children
  }));
};

export { ButtonGroup };
